import { Component, OnInit, Output, EventEmitter, Input } from "@angular/core";
import { IRuleElement } from "projects/sepidz-web-framework/src/lib/models";
import { ControlTypes } from "projects/sepidz-web-framework/src/lib/models/enums";
import { TranslateService } from "@ngx-translate/core";
import { CommonService } from "projects/sepidz-web-framework/src/lib/services/common.service";

@Component({
  selector: "setting-resource",
  templateUrl: "./settingresource.component.html",
  styleUrls: ["./settingresource.component.scss"],
})
export class SettingresourceComponent implements OnInit {
  @Output() public onResouceClicked = new EventEmitter<any>();
  @Output() public formSettingResourcesChange = new EventEmitter();
  _formSettingResources: IRuleElement[] = [];
  filterShow: boolean;
  activeSystemName?;

  @Input()
  public get formSettingResources(): IRuleElement[] {
    return this._formSettingResources;
  }
  public set formSettingResources(val: IRuleElement[]) {
    this._formSettingResources = val;
    this.formSettingResourcesChange.emit();
  }

  constructor(private translateservice: TranslateService, public common: CommonService) {}
  onClick(elements: any) {
    this.onResouceClicked.emit(elements);
    this.activeSystemName = elements;
  }
  ngOnInit(): void {
    this.makeSettingResources();
  }
  makeSettingResources() {
    if (!this._formSettingResources) this._formSettingResources = [];
    let re: IRuleElement = <IRuleElement>{};
    re.Title = this.translateservice.instant("ClientApp.GNR.MisSetup.SettingResource.Accounting");
    re.SystemName = "ACC";
    re.icon = "icon-file-document-multiple-outline";
    re.ControlType = ControlTypes.NumericTextBox;
    this._formSettingResources.push(re);
    re = <IRuleElement>{};
    re.Title = this.translateservice.instant("ClientApp.GNR.MisSetup.SettingResource.Inventory");
    re.SystemName = "INV";
    re.icon = "icon-anbar2";
    re.ControlType = ControlTypes.NumericTextBox;
    this._formSettingResources.push(re);
    re = <IRuleElement>{};
    re.Title = this.translateservice.instant("ClientApp.GNR.MisSetup.SettingResource.Sell");
    re.SystemName = "SELL";
    re.icon = "icon-shopping_basket-o";
    re.ControlType = ControlTypes.NumericTextBox;
    this._formSettingResources.push(re);
    re = <IRuleElement>{};
    re.Title = this.translateservice.instant("ClientApp.GNR.MisSetup.SettingResource.Trs");
    re.SystemName = "TRS";
    re.icon = "icon-payment-o";
    re.ControlType = ControlTypes.NumericTextBox;
    this._formSettingResources.push(re);
    re = <IRuleElement>{};
    re.Title = this.translateservice.instant("ClientApp.GNR.MisSetup.SettingResource.Payroll");
    re.SystemName = "HRM";
    re.icon = "icon-pie_chart-o";
    re.ControlType = ControlTypes.NumericTextBox;
    this._formSettingResources.push(re);
    re = <IRuleElement>{};
    re.Title = this.translateservice.instant("ClientApp.GNR.MisSetup.SettingResource.General");
    re.SystemName = "GNR";
    re.icon = "icon-people-o";
    re.ControlType = ControlTypes.NumericTextBox;
    this._formSettingResources.push(re);

    re = <IRuleElement>{};
    re.Title = this.translateservice.instant("ClientApp.GNR.MisSetup.SettingResource.SG");
    re.SystemName = "SG";
    re.icon = "icon-people-o";
    re.ControlType = ControlTypes.NumericTextBox;
    this._formSettingResources.push(re);
  }
}
